export default [
    {
        path: '/scheduler/calendar',
        name: 'CalendarScheduler',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Calendar',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/scheduler/calendar/SchedulerIndex.vue'),
            agent: () => import('@views/scheduler/calendar/SchedulerIndex.vue'),
        },
    },
];
